export const headerName = {
  add: "Добавить населенный пункт",
  edit: "Редактировать населенный пункт",
};
export const settlementsData = {
  oblastId: {
    key: "oblastId",
    label: "Область",
    type: "selectSearch",
    options: [],
    required: true,
  },
  nameRu: {
    key: "nameRu",
    label: "Наименование (рус.)",
    type: "text",
    required: true,
  },
  rayonId: {
    key: "rayonId",
    label: "Район",
    type: "selectSearch",
    options: [],
    required: true,
  },
  nameBy: {
    key: "nameBy",
    label: "Наименование (бел.)",
    type: "text",
    required: true,
  },
  categoryId: {
    key: "categoryId",
    label: "Категория населенного пункта",
    type: "selectSearch",
    options: [],
    required: true,
  },
  datein: {
    key: "datein",
    label: "Дата начала действия",
    type: "date",
    required: true,
  },
  dateout: {
    key: "dateout",
    label: "Дата окончания действия",
    type: "date",
  },
};

export const settlementsEditData = {
  oblast: {
    key: "oblast",
    label: "Область",
    type: "text",
    disabled: true,
  },
  nameRu: {
    key: "nameRu",
    label: "Наименование (рус.)",
    type: "text",
    disabled: true,
  },
  rayon: {
    key: "rayon",
    label: "Район",
    type: "text",
    disabled: true,
  },
  nameBy: {
    key: "nameBy",
    label: "Наименование (бел.)",
    type: "text",
    disabled: true,
  },
  categoryName: {
    key: "categoryName",
    label: "Категория населенного пункта",
    type: "text",
    disabled: true,
  },
  datein: {
    key: "datein",
    label: "Дата начала действия",
    type: "date",
    disabled: true,
  },
  dateout: {
    key: "dateout",
    label: "Дата окончания действия",
    type: "date",
    required: true,
  },
};

export const setDataSettlements = async (prop, field) => {
  if (prop) {
    switch (field) {
      case "oblastId": {
        settlementsData.oblastId.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "oblastId",
          };
        });
        break;
      }
      case "rayonId": {
        settlementsData.rayonId.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "rayonId",
          };
        });
        break;
      }
      case "categoryId": {
        settlementsData.categoryId.options = prop.map((item) => {
          return {
            label: item.label,
            value: item.id,
            key: "categoryId",
          };
        });
        break;
      }
    }
  }
};

export const getSettlementsModal = () => settlementsData;
export const getSettlementsEditModal = () => settlementsEditData;
